// extracted by mini-css-extract-plugin
module.exports = {"base":"NotifModal_base__3D49P","Header":"NotifModal_Header__1EMrD","Content":"NotifModal_Content__1vUtu"};